<template>
	<div class="pages">
		<WNav></WNav>
		<Back></Back>
		<div class="word">
			<el-card v-if="type == 1">
				<div class="type">{{$t('order.current')}}： {{
				obj.orderState === 0 ? $t('state.toexamine')
			  : obj.orderState === 1 ?  $t('state.upload')
              : obj.orderState === 2 ? $t('state.htToexamine')
              : obj.orderState === 3 ? $t('state.setup')
              : obj.orderState === 4 ? ($t('state.payment') + (obj.send === 1 ? '（'+$t('state.Shipped')+')' : ''))
              : (obj.orderState === 5 && num == 5 && obj.assFlag !== 1 &&  obj.assFlag !== 3)? (obj.send === 1 ? $t('state.Receipt') :$t('state.delivergoods'))
              : obj.orderState === 6 ? $t('state.htreject')
              : obj.orderState === 7 ? $t('state.ddreject')
              : (obj.orderState === 8 && num == 8 && obj.assFlag !== 1 &&  obj.assFlag !== 3 )? $t('state.Completed')
              : obj.orderState === 9 ?  $t('state.Cancelled')
			  : obj.assFlag === 1 ? $t('order.exchange')
			  : obj.assFlag === 3? $t('order.returngoods')
			  : obj.assFlag === 1 && num == 10? $t('order.exchange')
			  : obj.assFlag === 3 && num == 10? $t('order.returngoods')
			  : obj.assFlag === 2 && num == 10?  $t('order.hcomplete')
			  : obj.assFlag === 4&& num == 10? $t('order.tcomplete')
			  : obj.assFlag === 5 && num == 10? $t('order.Rejected'):$t('state.Completed')
            }}</div>
				<div class="dv">
					<div class="flex_start data"> <span class="bold">{{$t('order.shinformation')}}：</span>{{obj.receivingUser}}
						{{obj.receivingAddress}} {{obj.receivingPhone}}
					</div>
					<div class="flex_start data" v-if="obj.companyName && obj.logisticsOrderNo"> <span class="bold">{{$t('order.wlinformation')}}：</span>
						<span class="mr20">{{$t('order.wlcompany')}}：{{obj.companyName}}</span>
						{{$t('order.wlorderno')}}：{{obj.logisticsOrderNo}}
					</div>
					<div class="flex_start">
						<div> <span class="bold">{{$t('order.ddinformation')}}：</span> {{$t('order.number')}}：{{obj.orderNo}}</div>
						<div class="ml75">{{$t('order.Creationtime')}}：{{obj.createTime}}</div>
					</div>
					<div class="flex_start flex_warp">
						<div class="txt">{{$t('customizedApply.productName')}}：{{obj.productName}}</div>
						<div class="txt">{{$t('customizedApply.indexRequirement')}}：{{obj.indexRequirement}}</div>
						<div class="txt">{{$t('customizedApply.qualityGrade')}}：S{{obj.qualityGrade}}</div>
						<div class="txt">{{$t('customizedApply.sizeRequirement')}}：{{obj.sizeRequirement }}</div>
						<div class="txt">{{$t('customizedApply.demandQuantity')}}：{{obj.demandQuantity}}</div>
						<div class="txt">{{$t('customizedApply.weight')}}：{{obj.weight }}</div>
						<div class="txt">{{$t('customizedApply.deliveryCycle')}}：{{obj.deliveryCycle}}</div>
						<div class="txt">{{$t('customizedApply.installationMode')}}：{{obj.installationMode}}</div>
						<div class="txt">{{$t('customizedApply.useEnvironment')}}：{{obj.useEnvironment}}</div>
						<div class="txt">{{$t('customizedApply.otherProcessRequirements')}}：{{obj.otherProcessRequirements}}</div>
						<div class="txt">{{$t('customizedApply.detailedDescription')}}：{{obj.detailedDescription}}</div>
					</div>
					<div class="flex_between">
						<div class="flex_start">
							<a href="javascript:void(0)" class="pay" @click="linkToPay" v-if=" obj.assFlag < 1 && obj.orderState == 4">{{$t('order.payment')}}</a>
							<div class="btn" @click="open(obj.orderNo)">{{$t('order.contact')}}</div>
						</div>
						<div class="txt_l" v-if="payData.length > 0">
							<div class="price" :class="{'del':item.amountState == 1}" v-for="(item,index) in payData" :key="index">{{$t('order.d')}}{{index+1}}{{$t('order.q')}}：{{`${$type == 1?'￥':'$'}` + (item.payAmount / 100)}}</div>
							<div class="price">{{$t('order.Totalamount')}}：<span class="sun">{{`${$type == 1?'￥':'$'}` + obj.sun}}</span> </div>
						</div>
					</div>
				</div>
			</el-card>
			<el-card v-if="type == 0">
				<div class="type">{{$t('order.current')}}： {{
				obj_x.proOrderState === 1 ? $t('state.payment')
			: (obj_x.proOrderState === 2 && (num == 2 || num == '') && obj_x.assFlag !== 1 &&  obj_x.assFlag !== 3)? $t('state.delivergoods')
            : (obj_x.proOrderState === 3 && (num == 3 ||num == '') && obj_x.assFlag !== 1 &&  obj_x.assFlag !== 3)? $t('state.Distribution')
			: (obj_x.proOrderState === 4 && (num == 4 || num == '')&& obj_x.assFlag !== 1 &&  obj_x.assFlag !== 3)? $t('state.Completed')
			: obj_x.assFlag === 1 ? $t('order.exchange')
			: obj_x.assFlag === 3? $t('order.returngoods')
			: obj_x.assFlag === 1 && (num == 6 || num == '')? $t('order.exchange')
			: obj_x.assFlag === 3 && (num == 6 || num == '')? $t('order.returngoods')
			: obj_x.assFlag === 2 && (num == 6 || num == '')? $t('order.hcomplete')
			: obj_x.assFlag === 4&& (num == 6 || num == '')? $t('order.tcomplete')
			: obj_x.assFlag === 5 && (num == 6 || num == '')? $t('order.Rejected'):$t('order.Closed')
            }}</div>
				<div class="dv">
					<div class="flex_start data"> <span class="bold">{{$t('order.shinformation')}}：</span>
						{{obj_x.receivingUser}}
						{{obj_x.receivingAddress}}
						{{obj_x.receivingPhone}} </div>
					<div class="flex_start data" v-if="obj_x.logisticsNum && obj_x.logisticsName"> <span class="bold">{{$t('order.wlinformation')}}：</span>
						<span class="mr20">{{$t('order.wlcompany')}}：{{obj_x.logisticsName}}</span>
						{{$t('order.wlorderno')}}：{{obj_x.logisticsNum}}
					</div>
					<div class="flex_start">
						<div> <span class="bold">{{$t('order.ddinformation')}}：</span> {{$t('order.number')}}：{{obj_x.orderNo}}</div>
						<div class="ml75">{{$t('order.Creationtime')}}：{{obj_x.createTime}}</div>
					</div>
					<div class="flex_start flex_warp" v-if="type == 0">
						<div class="txt">{{$t('customizedApply.productName')}}：{{obj_x.productName}}</div>
						<div class="txt">{{$t('order.Productnumber')}}：{{obj_x.productNum}}</div>
						<div class="txt">{{$t('order.Productdescription')}}：S{{obj_x.productDescribe}}</div>
						<div class="txt">{{$t('order.UnitPrice')}}：{{`${$type == 1?'￥':'$'}` + (obj_x.unitPrice / 100)}}</div>
						<div class="txt">{{$t('order.Purchasequantity')}}：{{obj_x.num }}</div>
					</div>
					<div class="flex_between">
						<div class="flex_start">
							<a href="javascript:void(0)" class="pay" @click="linkToPay" v-if="obj_x.proOrderState === 1">{{$t('order.payment')}}</a>
							<div class="btn" @click="open(obj_x.orderNo)">{{$t('order.contact')}}</div>
						</div>
						<div class="txt_l" v-if="type == 0">
							<div class="price">{{$t('order.Totalamount')}}：<span class="sun">{{`${$type == 1?'￥':'$'}` + (obj_x.moneyNum / 100)}}</span> </div>
						</div>
					</div>
				</div>
			</el-card>
			<el-card v-if="type == 2">
				<div class="type">{{$t('order.current')}}： {{
            sample.orderState === 0 ? $t('state.toexamine') : sample.orderState === 1 ? $t('state.delivergoods'): sample.orderState === 2 ? $t('state.Receipt')
            :sample.orderState === 3 ? $t('state.Receivedgoods') : sample.orderState === 4 ? $t('state.Rejected') : $t('state.Cancelled')
            }}</div>
				<div class="dv">
					<div class="flex_start data"> <span class="bold">{{$t('order.shinformation')}}：</span>
						{{sample.receivingUser}}
						{{sample.receivingAddress}}
						{{sample.receivingPhone}} </div>
					<div class="flex_start data" v-if="sample.logisticsNum && sample.logisticsName"> <span class="bold">{{$t('order.wlinformation')}}：</span>
						<span class="mr20">{{$t('order.wlcompany')}}：{{sample.logisticsName}}</span>
						{{$t('order.wlorderno')}}：{{sample.logisticsNum}}
					</div>
					<div class="flex_start">
						<div> <span class="bold">{{$t('order.ddinformation')}}：</span> {{$t('order.number')}}：{{sample.orderNo}}</div>
						<div class="ml75">{{$t('order.Creationtime')}}：{{sample.createTime}}</div>
					</div>
					<div class="flex_start flex_warp">
						<div class="txt">{{$t('customizedApply.productName')}}：{{sample.productName}}</div>
						<div class="txt">{{$t('order.Productnumber')}}：{{sample.productNum}}</div>
						<div class="txt">{{$t('order.Productdescription')}}：{{sample.productDescribe}}</div>
					</div>
					<div class="flex_between">
						<div class="flex_start">
							<div class="btn" @click="open(sample.orderNo)">{{$t('order.contact')}}</div>
						</div>
					</div>
				</div>
			</el-card>
		</div>
		<!-- 	售后申请 -->
		<el-dialog :title="$t('order.Aftersales')" :visible.sync="dialogVisible" width="30%" @close="close">
			<div class="flex_center mb10">
				<div class="t_tittle">{{$t('order.AftersalesType')}}:</div>
				<el-select v-model="value" :placeholder="$t('order.Pleaseselect')" class="inp" @change="types" clearable>
					<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="flex_center">
				<div class="t_tittle">{{$t('order.AftersalesReason')}}:</div>
				<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" :placeholder="$t('order.input')" v-model="textarea"
				 class="inp">
				</el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('order.Cancel')}}</el-button>
				<el-button type="primary" @click="determine">{{$t('order.determine')}}</el-button>
			</span>
		</el-dialog>
		<!--聊天窗口-->
		<MessageWindow v-if="showChatWindow" @closeWindow="closeWindowFn" :getId="chatParams.getId" :objectId="chatParams.objectId"
		 :objType="chatParams.objtype"></MessageWindow>
		<FooterModel></FooterModel>
	</div>
</template>
<script>
	import Back from "../../assembly/Back";
	import WNav from "../../assembly/WhiteNav";
	import FooterModel from "../../assembly/Footer";
	import MessageWindow from '../message/MessageWindow.vue';
	export default {
		components: {
			Back,
			WNav,
			FooterModel,
			MessageWindow
		},
		name: "OrderDetail",
		data() {
			return {
				orderNo:'',
				chatParams: {
					getId: '10000',
					objectId: '',
					objtype: ''
				},
				showChatWindow: false,
				payData: [],
				type: "",
				obj: {},
				num: "",
				serviceType: "",
				textarea: "",
				options: [{
					value: '1',
					label: '退货'
				}, {
					value: '2',
					label: '换货'
				}],
				value: '',
				dialogVisible: false,
				obj_x: {},
				sample: {},
			};
		},
		mounted() {
			this.options = this.$t('order.options')
			this.num = this.$route.query.num ? this.$route.query.num : ''
			this.type = this.$route.query.type
			this.orderNo = this.$route.query.orderNo
			if (this.type == 0) {
				this.getData()
				this.chatParams.objtype = 1
			} else if (this.type == 1) {
				this.getDet()
				this.chatParams.objtype = 2
			} else {
				this.getsample()
				this.chatParams.objtype = 3
			}
		},
		methods: {
			//关闭弹窗
			closeWindowFn() {
				this.showChatWindow = false;
			},
			//立即付款的实现
			linkToPay() {
				let data;
				let price = []
				if (this.type == 0) {
					data = this.obj_x
				} else {
					data = this.obj
					data.amountListVos.map(item => {
						if (item.amountState == 0) {
							price.push(item)
						}
					})
				}
				this.$confirm(this.$t('order.title'), this.$t('Tips.Tips'))
					.then(() => {
						//组装数据传入支付页面
						let routerData = {
							payAmount: this.type == 0 ? data.moneyNum : price[0].amount,
							zhMoney: this.type == 0 ? data.moneyNumZh : '',
							orderNo: data.orderNo,
							pageName: "成品订单支付",
							orderType: this.type //成品订单
						};
						//显示弹窗
						sessionStorage.setItem("paydatainfo", JSON.stringify(routerData));
						let routerLinkData = this.$router.resolve({
							path: "/payPage"
						});
						window.open(routerLinkData.href, "_blank");
					})
					.catch(res => {
						console.log(res, "取消支付");
					});
			},
			// 关闭弹框
			close() {
				this.textarea = ''
				this.value = ''
			},
			open(id) {
				this.chatParams.objectId = id
				this.showChatWindow = true
			},
			//组装第一期数据
			find1stPay(payData = [], data = []) {
				let details = [],
					payAmount = 0,
					ids = '',
					amountState = 0,
					payTime = '',
					invoiceFlag = ''
				let payFlag = 0;
				//遍历第一期的详情
				data.forEach((item, index) => {
					if (item.headAmount === 1) {
						amountState = item.amountState;
						ids += item.purchaseId + ',';
						payAmount += item.amount;
						invoiceFlag = item.invoiceFlag
						details.push({
							key: item.nameOfMoney,
							value: item.amount
						});
					} else {
						payData.push({
							details: [{
								key: item.nameOfMoney,
								value: item.amount
							}],
							payAmount: item.amount,
							ids: item.purchaseId,
							amountState: item.amountState,
							invoiceFlag: item.invoiceFlag
						});
					}
				});
				if (payAmount <= 0) return;
				ids = ids.substring(0, ids.length - 1);
				payData.unshift({
					details,
					payTime,
					payAmount,
					ids,
					amountState,
					invoiceFlag
				})
				this.payData = payData
				let num = null
				payData.map(item => {
					num += (item.payAmount / 100)
				})
				this.obj.sun = num
			},
			// 售后类型
			types(e) {
				this.serviceType = e
			},
			// 确认售后
			determine() {
				if (this.serviceType == '') {
					this.$message({
						message: this.$t('Tips.Aftersalestype'),
						type: 'warning'
					});
					return false
				}
				if (this.textarea == '') {
					this.$message({
						message: this.$t('Tips.Aftersalesdescription'),
						type: 'warning'
					});
					return false
				}
				let token = sessionStorage.getItem('token')
				let that = this;
				let url = `/api/back/service/add`;
				let data = {
					orderType: 2,
					orderNo: this.orderNo,
					questionContent: this.textarea,
					serviceType: this.serviceType,
					token: token
				}
				this.$post(url, data).then(res => {
					this.options = []
					this.textarea = ''
					this.dialogVisible = false
					if (res.code == 0) {
						this.$message({
							message: this.$t('Tips.applysuc'),
							type: 'success'
						});
					}
				});
			},
			getDet() {
				let url = `/api/customized/order/detail`
				let data = {
					orderNo:this.$route.query.id,
					token:sessionStorage.getItem('token')
				}
				this.$get(url,data).then(res => {
					if (res.code == 0) {
						this.obj = res.data
					}
					this.find1stPay([], this.obj.amountListVos)
				});
			},
			getData() {
				let url = `/api/standard/order/detail`
				let data = {
					orderNo:this.$route.query.id,
					token:sessionStorage.getItem('token')
				}
				this.$get(url,data).then(res => {
					if (res.code == 0) {
						this.obj_x = res.data
					}
				});
			},
			getsample() {
				let url = `/api/order/details`
				let data = {
					orderNo: this.$route.query.id,
					token: sessionStorage.getItem('token')
				}
				this.$post(url, data).then(res => {
					if (res.code == 0) {
						this.sample = res.data
					}
				});
			},
		},

	};
</script>
<style scoped>
	.mb10{
		margin-bottom: 10rpx;
	}
	.txt_l{
		text-align: left;
	}
	.mr20{
		margin-right: 20px;
	}
	.bold{
		font-weight: bold;
	}
	.ml75{
		margin-left: 75px;
	}
	.del {
		text-decoration: line-through;
	}

	.pay {
		background-image: linear-gradient(#3f9fea, #0a77ce);
		color: #fff;
		width: 88px;
		height: 30px;
		text-align: center;
		line-height: 30px;
		margin-top: 10px;
		margin-right: 10px;
	}

	.inp {
		width: 60% !important;
		margin-left: 20px;
	}

	.t_title {
		font-size: 16px;
	}

	.type {
		width: 90%;
		line-height: 47px;
		padding-left: 25px;
		text-align: left;
		border: #0A76CE solid 1px;
		background: #f3f8fd;
		margin: 40px auto 20px auto;
		font-weight: bold;
	}

	.dv {
		width: calc(90% - 25px);
		padding: 25px;
		border: #0A76CE solid 1px;
		margin: 0 auto 40px auto;
	}

	.data {
		padding-bottom: 20px;
		border-bottom: #E2E2E2 solid 1px;
		margin-bottom: 20px;
	}

	.flex_warp {
		text-align: left;
		padding: 20px 30px 0 30px;
		border: #E2E2E2 solid 1px;
		margin-top: 25px;
		margin-bottom: 20px;
	}

	.txt {
		width: 30%;
		margin-bottom: 30px;
	}

	.btn {
		/* width: 88px; */
		height: 30px;
		line-height: 30px;
		margin-right: 10px;
		color: #666666;
		border: 1px solid rgba(204, 204, 204, 1);
		cursor: pointer;
		position: relative;
		margin-top: 10px;
		padding:0 10px
	}

	.flex_between {
		align-items: flex-start;
	}

	.price {
		margin-bottom: 10px;
		font-weight: bold;
	}

	.sun {
		font-size: 20px;
		color: #EA2323;
	}
</style>



// WEBPACK FOOTER //
// src/components/memberCenter/order/OrderDetail.vue